import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarStatusIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.9601 11.1098V16.9498C19.9601 18.0498 19.0801 18.9498 17.9801 18.9498C17.1201 18.9498 16.2401 18.4298 16.0201 17.3498H7.98008C7.76008 18.4298 6.88008 18.9498 6.02008 18.9498C4.92008 18.9498 4.04008 18.0498 4.04008 16.9498V11.1098L4.52008 10.1298H3.08008V8.52981H5.28008L6.96008 5.0498H17.0401L18.7201 8.52981H20.9201V10.1298H19.4801L19.9601 11.1098ZM16.1001 6.54981H7.90008L5.54008 11.1498V16.6498C5.54008 17.0298 5.84008 17.3298 6.22008 17.3298C6.60008 17.3298 6.88008 17.0298 6.88008 16.6498V15.8498H17.1201V16.6498C17.1201 17.0298 17.4001 17.3298 17.7801 17.3298C18.1601 17.3298 18.4601 17.0298 18.4601 16.6498V11.1498L16.1001 6.54981ZM11.324 9.01372L10.8181 8.00448L10.0838 8.86197L8.97169 10.1607H7.00008V11.6607H9.31686H9.66203L9.88653 11.3985L10.4889 10.6951L11.988 13.6859L12.5051 14.7175L13.2378 13.826L15.0178 11.6607H17.0001V10.1607H14.6634H14.3091L14.0841 10.4345L12.8119 11.9821L11.324 9.01372Z"
      />
    </SvgIcon>
  );
});
